function search() {
    /**
     * https://developers.google.com/custom-search/docs/element#javascript
     *
     * Google Custom Search configured with `matrixwebmaster1999`
     */
    // if (location.pathname == "/search-results/") {
    //     (function() {
    //         var cx = "015870105778908594253:hlp1aa-n5j0";
    //         var gcse = document.createElement("script");
    //         gcse.type = "text/javascript";
    //         gcse.async = true;
    //         gcse.src = "https://cse.google.com/cse.js?cx=" + cx;
    //         var s = document.getElementsByTagName("script")[0];
    //         s.parentNode.insertBefore(gcse, s);
    //     })();
    // }

    // var initSearch = function() {
    //     if (document.readyState == "complete") {
    //         // Document is ready when CSE element is initialized.
    //         // Render an element with both search box and search results in div with id 'test'.
    //         google.search.cse.element.render({
    //             div: "gcse-search-results",
    //             tag: "searchresults-only"
    //         });
    //     } else {
    //         // Document is not ready yet, when CSE element is initialized.
    //         google.setOnLoadCallback(function() {
    //             // Render an element with both search box and search results in div with id 'test'.
    //             google.search.cse.element.render({
    //                 div: "gcse-search-results",
    //                 tag: "searchresults-only"
    //             });
    //         }, true);
    //     }
    // };

    // // Insert it before the CSE code snippet so that cse.js can take the script
    // // parameters, like parsetags, callbacks.
    // window.__gcse = {
    //     parsetags: "explicit",
    //     callback: initSearch
    // };
    $('.search-form').on('submit', function (e) {
        e.preventDefault();
        var searchPhrase = $(this).find('[name=searchQuery]').val();
        goToSearchResults(searchPhrase);
    });
    function goToSearchResults(searchPhrase) {
        var resultsUrl = '/search-results/?searchQuery=';
        window.location.href = resultsUrl + encodeURIComponent(searchPhrase || '');
    }
    (function ($) {
        function closeSearch() {
            $(".search-wrap").addClass("animated fadeOutDownBig");
        }

        $(function () {
            $(".search-wrap").on(
                "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
                function () {
                    if ($(this).hasClass("fadeIn")) {
                        $(this).removeClass("fadeIn");
                    }

                    if ($(this).hasClass("fadeOutDownBig")) {
                        $(this).removeClass("fadeOutDownBig animated");
                    }
                }
            );

            $(".search-wrap__close").on("click touch", function () {
                closeSearch();
            });

            $(".search-trigger").on("click touch", function () {
                $(".search-wrap").addClass("animated fadeIn");
                $(".search-wrap .search-field").focus();
            });
        });
    })(jQuery);
}

export default search;



// WEBPACK FOOTER //
// ./src/js/partials/search.js